<template>
  <div style="padding-top:10px" class="ant-pro-multi-tab">
    <div class="ant-pro-multi-tab-wrapper">
      <a-tabs
        hideAdd
        type="card"
        :tabBarStyle="tabBarStyle"
        v-model="tabActiveKey"
        @change="change"
      >
        <a-tab-pane
          style="height: 0"
          v-for="page in chilidrenMenu"
          :tab="page.meta.title"
          :key="page.path"
        ></a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { constantRouterMap } from '@/router/modules/router.config'
// import { mapState } from 'vuex'
export default {
  name: 'TitleTab',
  props: {
    pages: {
      type: Array,
      default: () => {
        return []
      },
    },
    activeKey: {
      type: String,
      default: '',
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  components: {
    constantRouterMap,
  },
  watch: {
    $route: function(newVal) {
      this.tabActiveKey = newVal.fullPath
    },
    activeKey: function (newPathKey) {
      this.tabActiveKey = newPathKey
    },
    tabActiveKey: function (newPathKey) {
      this.$router.push({ path: newPathKey })
    },
  },
  computed: {
    chilidrenMenu() {
      if (this.pages && this.select) {
        return this.pages
      }
      if (this.$store.state.menuChildren.childrenMenuPage) {
        return this.$store.state.menuChildren.childrenMenuPage
      }
      return JSON.parse(localStorage.getItem('pro__childrenMenuPage')).value
    },
  },
  data() {
    return {
      tabBarStyle: { background: '#FFF', margin: 0, paddingLeft: '16px', paddingTop: '1px' },
      // chilidrenMenu: this.$store.state.menuChildren.childrenMenuPage,
      tabActiveKey: '',
      // activeKey: this.$store.state.menuChildren.activeKey
    }
  },
  methods: {
    callback(key) {
      console.log(key)
    },
    change(key) {
      this.tabActiveKey = key
      this.$router.push({ path: key })
    },
  },
}
</script>
